import { cn } from "@/lib/utils";

export function PageHeader({ overline, title, description, actions, className }) {
  return (
    <div className={cn("mb-8 flex items-start justify-between gap-4 flex-wrap", className)}>
      <div>
        {overline && <div className="overline mb-2">{overline}</div>}
        <h1 className="font-heading font-black text-3xl sm:text-4xl text-zinc-900 tracking-tight">
          {title}
        </h1>
        {description && (
          <p className="text-sm text-zinc-500 mt-2 max-w-2xl">{description}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
